export const ITEMS = [
  {
    id: 0,
    title: "Nikon EOS DSLR",
    category: "cameras",
    image: "assets/images/camera.jpg",
    price: 15,
    brand: "Nikon",
    condition: "Great",
    model: "N-EOS-442",
    year: 2006,
    comment: "the main screen has been replaced with brand new parts.",
  },
  {
    id: 1,
    title: "T-fal Electric Kettle",
    category: "Kitchen Appliance",
    image: "assets/images/elec-kettle.jpg",
    price: 5,
    brand: "T-fal",
    condition: "Good",
    model: "T-K04",
    year: 2017,
    comment: "The filter has been replaced with a new one.",
  },
  {
    id: 2,
    title: "Portable Air Conditioner",
    category: "ACs",
    image: "assets/images/port-ac2.jpeg",
    price: 80,
    brand: "LG",
    condition: "Great",
    model: "LG-AC-3800",
    year: 2019,
    comment: "The internal fan has been replaced. For a room up to 600 sq. ft.",
  },
  {
    id: 3,
    title: "Vacuum Cleaner",
    category: "Cleaning",
    image: "assets/images/vac.jpeg",
    price: 120,
    brand: "Dyson",
    condition: "Good",
    model: "D-1050",
    year: 2021,
    comment: "The extending cord has been replaced.",
  },
  {
    id: 4,
    title: "Tablet - iPad Air",
    category: "Computers",
    image: "assets/images/ipad-air.jpeg",
    price: 200,
    brand: "Apple",
    condition: "Great",
    model: "A7563",
    year: 2021,
    comment: "Minor scratches on the back",
  },
  {
    id: 5,
    title: "Ultrasonic Humidifier",
    category: "Humidifiers",
    image: "assets/images/humidfier.jpeg",
    price: 25,
    brand: "Vicks",
    condition: "Great",
    model: "MDYZ-C",
    year: 2020,
    comment: "Comes with the original box.",
  },
];